import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import firebase from '@firebase/app';
//import { auth } from 'firebase';


/* webpack chunk-name firebase */
import '@firebase/auth';

import vuetify from './plugins/vuetify';
import VueI18n from 'vue-i18n'
import '@babel/polyfill'
import Vuex from 'vuex'
import store from './store'
//() =>
Vue.use(Vuex)
import messages_en from '@/lang/en'
import messages_fr from '@/lang/fr'
Vue.use(VueI18n)
Vue.config.productionTip = false
const getNavigatorLanguage = () => (navigator.languages && navigator.languages.length) ? navigator.languages[0] : navigator.userLanguage || navigator.language || navigator.browserLanguage || 'en';
var configOptions = {"dev":{
    apiKey: "AIzaSyDnqF8m8IVeQTmVBsQ3Iz9aNWh7L7Zdq68",
    authDomain: "gofrance-dev.firebaseapp.com",
    databaseURL: "https://gofrance-dev.firebaseio.com",
    projectId: "gofrance-dev",
    storageBucket: "gofrance-dev.appspot.com",
    messagingSenderId: "955856492053",
    appId: "1:955856492053:web:b5175d641ae61df83ae01c"
  } , "prod": {
    apiKey: "AIzaSyBgW1MYSndZiWaCpgqOMiwPLyy8igcxdwk",
     authDomain: "gofrance-7eb17.firebaseapp.com",
     databaseURL: "https://gofrance-7eb17.firebaseio.com",
     projectId: "gofrance-7eb17",
     storageBucket: "gofrance-7eb17.appspot.com",
     messagingSenderId: "448361569742",
     appId: "1:448361569742:web:1251576e085db9d9"
  }};

  firebase.initializeApp(configOptions[process.env.VUE_APP_DB]);
  firebase.auth().onAuthStateChanged(user => {
    //store.dispatch("fetchUser", user);
    if (user) {
      user.getIdTokenResult().then((idTokenResult) => {
        let claims = idTokenResult.claims;
        let roles = [];

        if (claims.admin) {
          roles.push('admin');
        }
        if (claims.partner) {
          roles.push('partner');
        }
        store.dispatch('setRoles', roles);
      });
    }

    store.dispatch("fetchUser", user).then(() => {
      if (user) {
          firebase.firestore().collection('validations').where('player', '==', user.uid).get().then(s => {
            let validations = s.docs.map(v => {
              return v.data();
            });
            store.dispatch("setValidations", validations)


          })
      }

      //On va checker dans les validations

    })


  });







const i18n = new VueI18n({
  locale: getNavigatorLanguage().substring(0,2), // set locale
  //locale: 'fr',
  fallbackLocale: 'fr',
  messages: {... messages_en, ...messages_fr} // set locale messages
})
new Vue({
  router,
  vuetify,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
